import type { Me } from "@archinventory/client";
import type { QueryClient } from "@tanstack/react-query";
import { redirect } from "@tanstack/react-router";
import { ApiError, api, qk, unwrap } from "./api";

export const meQuery = {
  queryKey: qk.me,
  queryFn: () => unwrap(api.me.$get()),
  staleTime: 5 * 60_000,
};

/** For route guards: the current user, or redirect to /login. */
export async function requireMe(qc: QueryClient, href: string): Promise<Me> {
  try {
    return await qc.ensureQueryData(meQuery);
  } catch (err) {
    if (err instanceof ApiError && err.status === 401)
      throw redirect({ to: "/login", search: { redirect: href } });
    throw err;
  }
}
